import { GOOGLE_PLAY_QR_CODE_SRC } from "@/config/googlePlay";

type Props = {
  ariaLabel: string;
  className?: string;
  containerClassName?: string;
  imgClassName?: string;
};

export function GooglePlayQrCode({
  ariaLabel,
  className,
  containerClassName = "h-9 w-9 shrink-0 rounded-md bg-white p-0.5 md:h-10 md:w-10",
  imgClassName = "h-full w-full object-contain",
}: Props) {
  return (
    <div className={`${containerClassName}${className ? ` ${className}` : ""}`}>
      <img
        src={GOOGLE_PLAY_QR_CODE_SRC}
        alt={ariaLabel}
        decoding="async"
        className={imgClassName}
      />
    </div>
  );
}
